"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "zh": {
        "translation": {
            "page_header": {
                "example": "示例",
                "icons": {
                    "academy": "学校",
                    "asset_inventory": "资产库存",
                    "assets_and_attributes": "资产和属性",
                    "assurance_plans": "保障计划",
                    "bulk_importer": "批量导入程序",
                    "compliance_maps": "合规地图",
                    "community": "社区",
                    "frameworks": "框架",
                    "issue_tracker": "问题跟踪器",
                    "launchpad": "启动面板",
                    "mission_control": "任务控制",
                    "projects": "项目",
                    "reports": "报告",
                    "results": "结果",
                    "robots": "机器人",
                    "scheduler": "计划器",
                    "storyboard": "Storyboard",
                    "strategy": "战略",
                    "task_tracker": "任务跟踪器",
                    "time_sheets": "时间表",
                    "toolkits": "工具包"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=zh.js.map